import { render, staticRenderFns } from "./ProfesorLogIn.vue?vue&type=template&id=5d7d0dcd&"
import script from "./ProfesorLogIn.vue?vue&type=script&lang=js&"
export * from "./ProfesorLogIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports